import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { getFirstLetterOfNameOrEmail } from "~/core/generic/common-utils";
import { cn } from "~/core/generic/shadcn-utils";
import { Avatar, AvatarFallback, AvatarImage } from "~/core/ui/Avatar";
import If from "~/core/ui/If";

import { faBullseyeArrow } from "@fortawesome/pro-regular-svg-icons";

export type AvatarWithFallbackProps = {
  src?: string;
  alt?: string;
  size?: number;
  fallbackAlt: string;
  shape?: "circle" | "square";
  objectType?: "account" | "contact" | "opportunity";
  className?: string;
  style?: React.CSSProperties;
};

export default function AvatarWithFallback({
  alt,
  src,
  size = 18,
  fallbackAlt,
  objectType = "contact",
  shape = "circle",
  className,
  style,
}: AvatarWithFallbackProps) {
  return (
    <Avatar
      className={cn("rounded-full", className, {
        "!rounded-radius-4 border border-white-a3": shape === "square",
      })}
      style={{ height: size, width: size, ...style }}
    >
      <AvatarImage
        className="!border-none object-cover"
        src={src}
        alt={alt || fallbackAlt}
      />
      <AvatarFallback
        className={cn("bg-light text-light font-medium select-none", {
          "!rounded-base": shape === "square",
        })}
        style={{
          fontSize: `${size * 0.6}px`,
        }}
      >
        <If condition={objectType === "contact" || objectType === "account"}>
          {getFirstLetterOfNameOrEmail({ name: alt, email: fallbackAlt })}
        </If>
        <If condition={objectType === "opportunity"}>
          <FontAwesomeIcon icon={faBullseyeArrow} />
        </If>
      </AvatarFallback>
    </Avatar>
  );
}
